import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 30000,
});

export const getRecommendations = async (answers) => {
  const { data } = await api.post("/quiz/recommend", answers);
  return data;
};

export const saveQuiz = async (answers, top_paddles) => {
  const { data } = await api.post("/quiz/save", { answers, top_paddles });
  return data;
};

export const getSavedQuiz = async (id) => {
  const { data } = await api.get(`/quiz/${id}`);
  return data;
};

export const listPaddles = async (limit = 100) => {
  const { data } = await api.get(`/paddles?limit=${limit}`);
  return data;
};

// ---- Admin ----

const authHeaders = (token) => ({ headers: { "X-Admin-Token": token } });

export const adminVerify = async (token) => {
  const { data } = await api.post("/admin/verify", {}, authHeaders(token));
  return data;
};
export const adminGetConfig = async (token) => {
  const { data } = await api.get("/admin/config", authHeaders(token));
  return data;
};
export const adminPutConfig = async (token, cfg) => {
  const { data } = await api.put("/admin/config", cfg, authHeaders(token));
  return data;
};
export const adminVendors = async (token) => {
  const { data } = await api.get("/admin/vendors", authHeaders(token));
  return data.vendors;
};
export const adminPaddles = async (token, { q = "", vendor = "", limit = 60, skip = 0 } = {}) => {
  const params = new URLSearchParams({ q, vendor, limit, skip }).toString();
  const { data } = await api.get(`/admin/paddles?${params}`, authHeaders(token));
  return data;
};
export const adminPreview = async (token, answers) => {
  const { data } = await api.post("/admin/preview", answers, authHeaders(token));
  return data;
};
